import script from "./TeacherLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherLogin.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./TeacherLogin.vue?vue&type=style&index=1&id=f1de8046&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1de8046"]])

export default __exports__